import { render, staticRenderFns } from "./power.vue?vue&type=template&id=04e2fade&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&id=04e2fade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2fade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e2fade')) {
      api.createRecord('04e2fade', component.options)
    } else {
      api.reload('04e2fade', component.options)
    }
    module.hot.accept("./power.vue?vue&type=template&id=04e2fade&scoped=true&", function () {
      api.rerender('04e2fade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exception/power/power.vue"
export default component.exports